import React, { Component } from 'react'
import { Label } from 'office-ui-fabric-react/lib/Label'
import { DefaultButton } from 'office-ui-fabric-react/lib/Button'
import { Overlay } from 'office-ui-fabric-react/lib/Overlay'
import {
  Spinner,
  SpinnerSize
} from 'office-ui-fabric-react/lib/Spinner'
import ebLogo from './eb_logo.png'
import SearchSourceTabs from './SearchSourceTabs'
import SearchSourceInput from './SearchSourceInput'
import SearchResults from './SearchResults'
import StyleSelect from './StyleSelect'
import ConfirmDialog from './ConfirmDialog'
import CitationList from './CitationList'
import {
  SearchSources,
  SearchResultList,
  CitationStyleSelect,
  ProjectCitationList,
} from "@chegg-wt/redux-citation-api";

import './App.css'

class App extends Component {
  render() {
    return (
      <div>
        <ConfirmDialog />
        {this.props.isLoading && <Overlay isDarkThemed={ true } className="eb-overlay">
            <div className="eb-loading-spinner">
              <Spinner size={ SpinnerSize.large } label='Loading...' ariaLive='assertive' />
            </div>
          </Overlay>
        }
        <Label>Search for your source</Label>
        <SearchSources tabComponent={SearchSourceTabs} searchComponent={SearchSourceInput} />
        <hr class="hr-divider" />
        { this.props.page === 'search' &&
          <SearchResultList listComponent={SearchResults} />
        }
        { this.props.page === 'citations' &&
        <div class="reference-section">
          <Label>References</Label>
          <CitationStyleSelect selectComponent={StyleSelect} selected={this.props.style} />
          <div class="citation-list">
            <ProjectCitationList listComponent={CitationList} />
          </div>
          <DefaultButton
            primary={ true }
            text='Insert bibliography'
            onClick={() => this.props.handleUpdateCitations(this.props.citations, this.props.style)}
            disabled={this.props.citations && this.props.citations.length === 0}
          />
        </div>
        }
        <div>
          <img width="104" class="logo" src={ebLogo} alt="EasyBib" />
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js